/**
 * WebhookSettings Firestore Converter (Client SDK)
 *
 * Client-side converter for use with firebase/firestore (NOT firebase-admin).
 * Converts between WebhookSettings TypeScript type and Firestore data.
 *
 * Использует WebhookSettingsFromJSON / WebhookSettingsToJSON чтобы маппить
 * snake_case Firestore-поля (ai_actor, ai_strategy) на camelCase TS-properties
 * (aiActor, aiStrategy) и обратно. Эти helpers сгенерированы из openapi-settings.yaml
 * через openapi-generator-cli (см. segmently-schema/scripts/generate-typescript-settings.sh).
 */

import { FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore';
import type { WebhookSettings } from '@segmently/schema-models/settings';
import {
  WebhookSettingsFromJSON,
  WebhookSettingsToJSON,
} from '@segmently/schema-models/settings/models';

export const webhookSettingsConverter: FirestoreDataConverter<WebhookSettings> = {
  toFirestore(settings: WebhookSettings): any {
    return WebhookSettingsToJSON(settings);
  },

  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options?: SnapshotOptions
  ): WebhookSettings {
    const data = snapshot.data(options);
    return {
      ...WebhookSettingsFromJSON(data),
      id: snapshot.id,
    };
  },
};

export default webhookSettingsConverter;
